// import { useContext, useEffect, useState } from 'react';
import MobileGreen from '../../../../Assets/StorefrontIcons/MobileGreen.svg';
import DesktopGray from '../../../../Assets/StorefrontIcons/DesktopGray.svg';
import MobileGray from '../../../../Assets/StorefrontIcons/MobileGray.svg';
import DesktopGreen from '../../../../Assets/StorefrontIcons/DesktopGreen.svg';
// import YellowAlert from '../../../../Assets/StorefrontIcons/YellowAlert.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType, setSectionType, setViewtype } from '../../../../Features/storefrontSlice';
// import { StorefrontContext } from '../../../../Context/StorefrontContext';

function ViewtypeButtons() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    // const {
    //     alert,
    //     // setAlert,
    //     // defaultAlert,
    //     // defaultCarouselAlert,
    // } = useContext(StorefrontContext);

    // const [hasAlert, setHasAlert] = useState(false);

    function updateViewtype(type) {
        dispatch(setViewtype(type));
        dispatch(setSectionType(null));
        dispatch(setSectionFormType(null));
    }

    // useEffect(() => {
    //     const anyCarouselAlert = alert.carouselBanner.some(banner => banner.bannerAlert);

    //     setHasAlert(
    //         alert.backgroundImage || 
    //         alert.singleBanner || 
    //         anyCarouselAlert
    //     );
    // }, [alert]);

    return (
        <div className="flex items-center gap-2">
            <div className="size-8 p-[5px] flex items-center justify-center">
                <button onClick={() => updateViewtype('DESKTOP')} className={`size-[26px] px-[3px] py-[2.5px] ${viewType === 'DESKTOP' && 'bg-[#A6FFCB] rounded'} flex items-center justify-center`}>
                    <img src={viewType === 'DESKTOP' ? DesktopGreen : DesktopGray} alt="" />
                </button>
            </div>

            <div className="size-8 p-[5px] flex items-center justify-center relative">
                <button onClick={() => updateViewtype('MOBILE')} className={`relative size-[26px] px-[3px] py-[2.5px] ${viewType === 'MOBILE' && 'bg-[#A6FFCB] rounded'} flex items-center justify-center`}>
                    <img src={viewType === 'MOBILE' ? MobileGreen : MobileGray} alt="" />
                </button>
            </div>
        </div>
    );
}

export default ViewtypeButtons;
